export default function removeLeadingZeroes(input: string): string {
  const parsedNumber = parseInt(input, 10)
  return isNaN(parsedNumber) ? '' : parsedNumber.toString()
}
